// Polyfill
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './polyfill';
// import './modules/core/hooks/use-why-did-you-render'; // Only for development => comment this line if it is annoying in console
// Libs
import React from 'react';
import { hydrate, render } from 'react-dom';
// Component
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging';
import { Workbox } from 'workbox-window';

import Providers from './Providers';
import Core from './modules/core';

import { isPassagesRoute } from './modules/qrcodes/helper';
import { scanQrCode } from './modules/qrcodes/actions';

const rootElement = document.getElementById('root');

const WebApp = () => (
    <Providers>
        <Core />
    </Providers>
);

if (isPassagesRoute) {
    const qrCodeHardwareId = window.location.pathname.match(/\/(?:qrcodes|passages)\/([a-zA-Z0-9_-]+)/);
    scanQrCode(qrCodeHardwareId ? qrCodeHardwareId[1] : null);
}

if (rootElement.hasChildNodes()) {
    hydrate(<WebApp />, rootElement);
} else {
    render(<WebApp />, rootElement);
}

const loader = document.getElementById('loader');
if (loader) {
    loader.style.display = 'none';
}

// Initialize Firebase with web app's Firebase configuration
const app = initializeApp(JSON.parse(FIREBASE_CONFIG));

let serviceWorkerRegistration = null;
// service worker should be registered when page is fully loaded to prevent conflicting with
// loading critical assets
// Example : window.addEventListener('load', function() {
// Ensure serviceWorker is available in this navigator
if (navigator.serviceWorker) {
    const wb = new Workbox('/service-worker.js');
    console.log('[service-worker] 1/3 - Registering ...')

    // updateViaCache ensures that the browser always checks for the latest version of the serviceworker
    wb.register({ updateViaCache: 'none' })
        .then(registration => {
            serviceWorkerRegistration = registration;

            // When the page loads, checks for a new version of the serviceworker
            // Manually triggering update checks
            console.log('[service-worker] 1/3 - Updating the registration ...')
            serviceWorkerRegistration.update();
        }).catch(error => {
            console.log('[service-worker] Error while registering the service worker')
            console.log(error);
            console.log(error.message);
        });
}

isSupported().then(async value => {
    if (value) {
        console.log('Browser supports Firebase');

        if (FIREBASE_CONFIG !== "{}") {
            // Initialize Firebase Cloud Messaging and get a reference to the service
            const messaging = getMessaging(app);

            onMessage(messaging, payload => {
                // STUB : Should be correlated with the in-app notification system. Currently not the case
                console.log('Message received. ', payload);
            });
            console.log('Firebase was successfully initialized');

        } else {
            console.error('Unable to initialize Firebase: Firebase config is missing');
        }

    } else {
        console.error('Browser does not support Firebase : this browser cannot subscribe to push notifications');
    }
});


async function askPermission() {
    console.log('Requesting permission to push notifications ...');

    // Initialize Firebase Cloud Messaging and get a reference to the service
    const messaging = getMessaging(app);

    return Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
            console.log('The user accepted the push notification permission request.');
            console.log(serviceWorkerRegistration);
            // Get token with VAPID public key to authorize send requests to web push services
            // Public and private keys are configured on the Firebase project
            return getToken(messaging, { serviceWorkerRegistration, vapidKey: PUSH_PUBLIC_APPLICATION_SERVER_KEY }).then(fcm_token => {
                if (fcm_token) {
                    console.log('Successfully got FCM token');
                    console.log('Current token is', fcm_token);
                    // Send the token to the server and update the UI if necessary
                    return fcm_token;
                } else {
                    // Show permission request UI
                    console.log('No FCM registration token available.');
                    throw new Error('No FCM registration token available.');
                }
            }).catch(err => {
                console.log('An error occurred while retrieving FCM token.', err);
                throw err;

                // ...
            });
        } else if (permission === 'denied') {
            console.error('The user explicitly denied the push notification permission request.');
            throw new Error('The user explicitly denied the push notification permission request.');

        } else {
            console.error('Unable to get push notification permission.');
            throw new Error('Unable to get push notification permission.');

        }
    }).catch(err => {
        console.log('An error occurred while getting push notification permission.', err);
        throw new Error('An error occurred while getting push notification permission.');

    });
}

export { askPermission };
